import { render } from "./qari.vue?vue&type=template&id=fab4ff94"
import script from "./qari.vue?vue&type=script&lang=js"
export * from "./qari.vue?vue&type=script&lang=js"
script.render = render

export default script